import * as PIXI from "pixi.js";
import {app, events} from "../utils/pixiApp";
import {Assets} from "pixi.js";
import {getDeviceMedia} from "../utils/sizes";

const sizes = {
    web: {
        width: 220,
    },
    mobile: {
        width: 88,
        height: 326
    }
}

export const gameBackground = () => {
    let mediaScreen = getDeviceMedia(app.screen.width)
    const height = mediaScreen === 'web' ? app.screen.height / 100 * 72 : 326;
    const width = sizes[mediaScreen].width;
    const appBg = new PIXI.Sprite(PIXI.Texture.from('background'));
    appBg.setSize(app.screen.width, app.screen.height);

    const columnLeft = new PIXI.Sprite(PIXI.Texture.from('column'));
    columnLeft.setSize(width, height);
    columnLeft.position.y = 0;
    columnLeft.position.x = -1;

    const columnRight = new PIXI.Sprite(PIXI.Texture.from('column'));
    columnRight.scale.x = -.45
    columnRight.setSize(width, height);
    columnRight.position.x = app.screen.width + 1;
    columnRight.position.y = 0;

    events.onScreenResizeEvent(() => {
        const media = getDeviceMedia(app.screen.width)
        appBg.setSize(app.screen.width, app.screen.height);
        columnRight.position.x = app.screen.width + 1;
        if(mediaScreen !== media) {
            mediaScreen = media
            if(media === 'web') {
                columnLeft.setSize(sizes.web.width, app.screen.height / 100 * 72)
                columnRight.setSize(sizes.web.width, app.screen.height / 100 * 72)
            }
        }
        if(media === 'mobile') {
            columnLeft.setSize(88, 326)
            columnRight.setSize(88, 326)
        }
    })

    return [appBg, columnLeft, columnRight]
}